import React from 'react';  // eslint-disable-line

const ShowPassword = (props) => {
    return (
        props.showpassword
            ? (
                <svg
                    onClick={props.toggleShowPassword}
                    className="svg-hide-password"
                    width="50"
                    height="51"
                    viewBox="0 0 50 51"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g fillRule="nonzero" fill="#444" opacity=".4">
                        <path d="M31.6 23.6l-8.2 8.2c.5.1 1.1.2 1.6.2 3.6 0 6.4-3.1 7.6-4.9.5-.7.5-1.6 0-2.3-.2-.3-.6-.7-1-1.2zM31.3 18.3L28.6 21c-1.1-.6-2.3-1-3.6-1-3.6 0-6.4 3.1-7.6 4.9-.5.7-.5 1.6 0 2.2.5.8 1.4 1.8 2.4 2.7l-2.5 2.5c-.4.4-.4 1 0 1.4.2.2.4.3.7.3.3 0 .5-.1.7-.3l14-14c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0zm-9 9c-.2-.4-.3-.8-.3-1.3 0-1.7 1.3-3 3-3 .5 0 .9.1 1.3.3l-4 4z" />
                    </g>
                </svg>
            ) : (
                <svg
                    onClick={props.toggleShowPassword}
                    className="svg-show-password"
                    width="50"
                    height="51"
                    viewBox="0 0 50 51"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M24.975 31c3.6 0 6.4-3.1 7.6-4.9.5-.7.5-1.6 0-2.3-1.2-1.7-4-4.8-7.6-4.8-3.6 0-6.4 3.1-7.6 4.9-.5.7-.5 1.6 0 2.2 1.2 1.8 4 4.9 7.6 4.9zm0-9c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3z"
                        fillRule="nonzero"
                        fill="#444"
                    />
                </svg>
            )
    );
};

export default ShowPassword;
